import { userStatus } from '@/api/employee';

function TextUserInactive({ status }: { status: userStatus }) {
  return (
    <span>
      {status === userStatus.INACTIVE && (
        <span className="text-red-500"> (Không hoạt động)</span>
      )}
    </span>
  );
}

export default TextUserInactive;
